/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsTermItem } from '../../models/profile-analytics-term-item';

export interface ProfileReferralsTypeHistogram$Params {
  id: number;
}

export function profileReferralsTypeHistogram(http: HttpClient, rootUrl: string, params: ProfileReferralsTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
  const rb = new RequestBuilder(rootUrl, profileReferralsTypeHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileAnalyticsTermItem>>;
    })
  );
}

profileReferralsTypeHistogram.PATH = '/analytics/profile/{id}/referrals';
